import { render, staticRenderFns } from "./NewSubCategory.vue?vue&type=template&id=d94a850a&"
import script from "./NewSubCategory.vue?vue&type=script&lang=js&"
export * from "./NewSubCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports